module.exports = __webpack_public_path__ + "assets/img/nodata.2d76acb8.png";